import {Outlet} from "react-router-dom";

const Visits = () => {
  return <Outlet/>
}

export default Visits;